<!-- Selection mode indicator border -->
<div 
  *ngIf="isTargetedBidMode"
  class="selection-mode-border-wrapper">
  <div class="selection-mode-border-black"></div>
  <div class="selection-mode-border-pink"></div>
</div>

<ng-container *ngIf="viewType !== 'compact' && punkData">
  
  <div class="header-wrapper">
    <div class="header-title-row">
      <div class="header-title-main">
        <h1>
          {{ marketTitles[marketType] }}
          <ng-container *ngIf="marketType === 'nftx-vault'">
            <ng-template [ngTemplateOutlet]="nftxIcon"></ng-template>
          </ng-container>
        </h1>

        <h2 *ngIf="address">by <app-wallet-address [address]="address" class="pink"></app-wallet-address></h2>

        <ng-container *ngIf="marketType !== 'sales'">
          <ng-container *ngIf="(stateSvc.marketLoading$ | async); else punkCount">
            <h3>Loading...</h3>
          </ng-container>

          <ng-template #punkCount>
            <h3>{{ (filteredPunks | count : marketType) | number }} {{ environment.tokenName }}s Total</h3>
            <div style="margin-top: 2rem;">
              <ng-container
                *ngIf="marketType === 'listings'">
                
                <button
                  #shareButton
                  class="share"
                  (click)="share(shareButton)">
                  
                  Share Floor Data
                </button>
                <button
                  *ngIf="environment.featureFlags?.STASH_BID_SUPPORT !== false"
                  [routerLink]="['/all']"
                  class="share"
                  style="margin-left: 1rem;">
                  View All Punks
                </button>
              </ng-container>
            </div>
          </ng-template>
        </ng-container>

        <ng-container *ngIf="marketType === 'sales'">
          <ng-container *ngIf="(stateSvc.marketLoading$ | async); else salesCount">
            <h3>Loading...</h3>
          </ng-container>
          <ng-template #salesCount>
            <h3>{{ (filteredPunks | count : marketType) | number }} {{ environment.tokenName }}s Total</h3>
            <button
              *ngIf="environment.featureFlags?.STASH_BID_SUPPORT !== false"
              [routerLink]="['/all']"
              class="share"
              style="margin-top: 2rem;">
              View All Punks
            </button>
          </ng-template>
        </ng-container>
      </div>

      <div
        class="highest-bid-banner"
        *ngIf="(marketType === 'all') && environment.featureFlags?.STASH_BID_SUPPORT !== false && !(stateSvc.marketLoading$ | async)">
        <span class="highest-bid-title">{{ highestBidBannerLabel }}</span>
        <div class="highest-bid-row">
          <ng-container *ngIf="highestBidForCriteriaLoading; else highestBidLoaded">
            <span class="highest-bid-label" *ngIf="hasActiveTraitFilters">Matching all tokens:</span>
            <span class="highest-bid-value">Loading...</span>
          </ng-container>
          <ng-template #highestBidLoaded>
            <ng-container *ngIf="highestBidForCriteria; else noBid">
              <span class="highest-bid-label" *ngIf="hasActiveTraitFilters">Matching all tokens:</span>
              <span
                class="highest-bid-value highest-bid-clickable"
                (click)="highestBidDetailsModalActive = true"
                title="View bid details">
                {{ highestBidForCriteria.bid_amount_eth | formatCash }}Ξ
                (${{ (highestBidForCriteria.bid_amount_eth * ((dataSvc.usd$ | async) || 0)) | formatCash }})
                <svg class="highest-bid-info-icon" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
                </svg>
              </span>
            </ng-container>
            <ng-template #noBid>
              <span class="highest-bid-label" *ngIf="hasActiveTraitFilters">Matching all tokens:</span>
              <span class="highest-bid-value">No bid for these criteria</span>
            </ng-template>
          </ng-template>
        </div>
        <div class="highest-bid-row highest-bid-row-secondary" *ngIf="hasActiveTraitFilters">
          <ng-container *ngIf="highestBidForCriteriaAnyLoading; else highestBidAnyLoaded">
            <span class="highest-bid-label">Matching at least one:</span>
            <span class="highest-bid-value">Loading...</span>
          </ng-container>
          <ng-template #highestBidAnyLoaded>
            <ng-container *ngIf="highestBidForCriteriaAny; else noBidAny">
              <span class="highest-bid-label">Matching at least one:</span>
              <span
                class="highest-bid-value highest-bid-clickable"
                (click)="highestBidAnyDetailsModalActive = true"
                title="View bid details">
                {{ highestBidForCriteriaAny.bid_amount_eth | formatCash }}Ξ
                (${{ (highestBidForCriteriaAny.bid_amount_eth * ((dataSvc.usd$ | async) || 0)) | formatCash }})
                <svg class="highest-bid-info-icon" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
                </svg>
              </span>
            </ng-container>
            <ng-template #noBidAny>
              <span class="highest-bid-label">Matching at least one:</span>
              <span class="highest-bid-value">No bid</span>
            </ng-template>
          </ng-template>
        </div>
      </div>
    </div>

    <div class="market-description" *ngIf="marketType === 'nftx-vault'">
      <p>NFTX offers a specialized vault for {{ environment.collectionTitle }}, allowing anyone to tokenize them into tradable ERC-20 tokens. This provides liquidity and DeFi potential for {{ environment.collectionTitle }} holders. Any punk available in the vault can be purchased at the current NFTX buy price.</p>
      <a href="https://v2.nftx.io/vault/{{environment.nftxVaultAddress}}/buy/" target="_blank" class="pink">View the {{ environment.collectionTitle }} Vault on NFTX<svg height="12" viewBox="0 0 12 12" width="12" xmlns="http://www.w3.org/2000/svg"><path d="m4 0v2h-2v8h8v-2h2v4h-12v-12zm2 6v2h-2v-2zm2 0h-2v-2h2v-2h-2v-2h6v6h-2v-2h-2z" fill-rule="evenodd" fill="rgba(var(--pink), 1)" /></svg></a>
    </div>

  </div>

  <!-- Selection cart / panier de sélection -->
  <div 
    *ngIf="isTargetedBidMode && selectedPunkIds.length > 0 && (marketType === 'all' || marketType === 'listings')"
    class="selection-cart">
    <div class="selection-cart-header">
      <h3>Selected Punks ({{ selectedPunkIds.length }})</h3>
      <button 
        class="clear-selection"
        (click)="clearSelection()"
        title="Clear selection">
        Clear
      </button>
    </div>
    <div class="selection-cart-items">
      <div 
        *ngFor="let punkId of selectedPunkIdsCartVisible"
        class="selection-cart-item"
        (click)="togglePunkSelection(punkId)">
        <img
          [lazyLoad]="dataSvc.staticUrl + dataSvc.tokenImagePath + (punkId | tokenIdParse) + '.svg'"
          [defaultImage]="environment.collection === 'cryptophunks' ? 'assets/loadingphunk.png' : 'assets/loadingpunk.png'"
          [alt]="'Punk #' + punkId"
          width="50"
          height="50"
        />
        <span class="punk-id">#{{ punkId }}</span>
        <button 
          class="remove-punk"
          (click)="togglePunkSelection(punkId); $event.stopPropagation()"
          title="Remove from selection">
          ×
        </button>
      </div>

      <button
        *ngIf="selectedPunkIdsCartOverflow.length > 0"
        type="button"
        class="selection-cart-item selection-cart-overflow-trigger"
        [class.open]="selectedPunksOverflowPanelOpen"
        (click)="toggleSelectedPunksOverflowPanel(); $event.stopPropagation()"
        [attr.aria-expanded]="selectedPunksOverflowPanelOpen"
        [attr.aria-label]="selectedPunksOverflowPanelOpen ? 'Close extra selected punks list' : ('Show ' + selectedPunkIdsCartOverflow.length + ' more selected punks')">
        <span
          class="selection-cart-overflow-count"
          [class.selection-cart-overflow-count-close]="selectedPunksOverflowPanelOpen">
          <ng-container *ngIf="!selectedPunksOverflowPanelOpen">+{{ selectedPunkIdsCartOverflow.length }}</ng-container>
          <ng-container *ngIf="selectedPunksOverflowPanelOpen">×</ng-container>
        </span>
        <span class="punk-id selection-cart-overflow-label">{{ selectedPunksOverflowPanelOpen ? 'close' : 'more' }}</span>
      </button>
    </div>

    <div
      *ngIf="selectedPunksOverflowPanelOpen && selectedPunkIdsCartOverflow.length > 0"
      class="selection-cart-overflow-panel">
      <div class="selection-cart-overflow-panel-scroll">
        <div
          *ngFor="let punkId of selectedPunkIdsCartOverflow"
          class="selection-cart-item"
          (click)="togglePunkSelection(punkId)">
          <img
            [lazyLoad]="dataSvc.staticUrl + dataSvc.tokenImagePath + (punkId | tokenIdParse) + '.svg'"
            [defaultImage]="environment.collection === 'cryptophunks' ? 'assets/loadingphunk.png' : 'assets/loadingpunk.png'"
            [alt]="'Punk #' + punkId"
            width="50"
            height="50"
          />
          <span class="punk-id">#{{ punkId }}</span>
          <button
            class="remove-punk"
            (click)="togglePunkSelection(punkId); $event.stopPropagation()"
            title="Remove from selection">
            ×
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="controls-wrapper">
    <button
      class="filters-toggle-button"
      [class.active]="controlsFiltersVisible"
      *ngIf="marketType !== 'all'"
      (click)="controlsFiltersVisible = !controlsFiltersVisible"
      title="Toggle quick filters">
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M3 6h18v2H3V6zm4 5h10v2H7v-2zm3 5h4v2h-4v-2z"></path>
      </svg>
    </button>

    <div class="filters-panel" *ngIf="controlsFiltersVisible">
      <div class="filters-row">
        <ng-container *ngIf="marketType !== 'nftx-vault'">
          <div
            class="sort-wrapper"
            *ngIf="!(stateSvc.marketLoading$ | async)"
            [class.disabled]="marketType === 'all'">

            <div class="label">Sort:</div>
            <ng-select
              [(ngModel)]="activeSortModel"
              [items]="sorts"
              (change)="setSort($event)"
              [searchable]="false"
              [clearable]="false">
            </ng-select>
          </div>

          <div
            *ngIf="(environment.collection === 'cryptophunks' || environment.collection === 'cryptopunks-v1' || environment.collection === 'cryptopunks') && marketType !== 'all'"
            class="marketplace-filter">

            <div class="label">Platform:</div>
            <ng-select
              [(ngModel)]="stateSvc.activeMarketplaceFilterModel"
              [items]="stateSvc.marketplaceFilters"
              (change)="stateSvc.setMarketplaceFilter($event)"
              [searchable]="false"
              [clearable]="false">
            </ng-select>
          </div>
        </ng-container>

        <div
          *ngIf="environment.collection === 'cryptopunks'"
          class="wrapped-filter"
          [class.disabled]="marketType !== 'listings'">

          <div class="label">Show:</div>
          <ng-select
            [(ngModel)]="activeWrappedFilterModel"
            [items]="wrappedFilters"
            (change)="setWrappedFilter($event)"
            [searchable]="false"
            [clearable]="false">
          </ng-select>
        </div>
      </div>
      <button
        class="filters-close-button"
        (click)="controlsFiltersVisible = false"
        title="Close quick filters">
        Close
      </button>
    </div>

    <div class="toolbar-wrapper">
      <div class="toolbar">
        <div class="left">
        </div>
        
        <div class="right">
        
          <button (click)="toggleMarketplaceIcons()" *ngIf="marketType === 'listings' || marketType === 'nftx-vault' || marketType === 'sales'" style="min-width: 12rem; justify-content: center;">
            {{ (stateSvc.hideMarketplaceIcons$ | async) ? 'Show' : 'Hide' }} Icons
          </button>

          <div *ngIf="isTargetedBidMode" class="targeted-id-controls">
            <input 
              type="text" 
              class="shared-input"
              [(ngModel)]="punkIdInput"
              (keydown)="onPunkIdInputKeyDown($event)"
              placeholder="Enter punk ID"
            />
            <button (click)="addPunkIdFromInput()" class="targeted-add-button">
              Add
            </button>
            <button
              type="button"
              (click)="addAllDisplayedPunksToSelection()"
              class="targeted-add-button targeted-add-all-button"
              [class.disabled]="addAllBulkInProgress || removeAllBulkInProgress"
              [disabled]="addAllBulkInProgress || removeAllBulkInProgress"
              tippy
              [options]="addAllDisplayedPunksTippyOptions">
              Add All
            </button>
            <span
              *ngIf="addAllBulkInProgress"
              class="targeted-bulk-loader"
              aria-live="polite"
              aria-busy="true">
              <app-loader></app-loader>
            </span>
            <div class="targeted-separator"></div>
          </div>

          <ng-container>
            <button (click)="filtersVisible = !filtersVisible">Trait filters</button>

            <ng-container *ngIf="isTargetedBidMode && filtersVisible">
              <button
                type="button"
                (click)="removeDisplayedPunksFromSelection()"
                class="targeted-add-button targeted-remove-all-button"
                [class.disabled]="removeAllDisplayedPunksDisabled || removeAllBulkInProgress || addAllBulkInProgress"
                [disabled]="removeAllDisplayedPunksDisabled || removeAllBulkInProgress || addAllBulkInProgress"
                tippy
                [options]="removeAllDisplayedPunksTippyOptions">
                Remove Trait
              </button>
              <span
                *ngIf="removeAllBulkInProgress"
                class="targeted-bulk-loader"
                aria-live="polite"
                aria-busy="true">
                <app-loader></app-loader>
              </span>
            </ng-container>
          </ng-container>

          <div 
            *ngIf="marketType === 'all' && environment.collection === 'cryptopunks'"
            style="width: 0.7rem; height: 0.7rem; background-color: rgba(var(--text-color), 0.3); flex-shrink: 0;">
          </div>

          <ng-container *ngIf="(marketType === 'all' || marketType === 'listings') && (environment.collection === 'cryptopunks' || environment.collection === 'cryptopunks-v1') && environment.featureFlags?.STASH_BID_SUPPORT !== false">
            
            <button (click)="openCreateCollectionBid()">
              {{ hasActiveTraitFilters ? 'Create Trait Bid' : 'Create Collection Bid' }}
            </button>
            
            <button 
              *ngIf="!isTargetedBidMode"
              (click)="toggleTargetedBidMode()">
              Create Custom Bid
            </button>
            
            <ng-container *ngIf="isTargetedBidMode">
              <button 
                (click)="openCreateCollectionBid()"
                [class.disabled]="selectedPunkIds.length === 0"
                [disabled]="selectedPunkIds.length === 0"
                class="targeted-bid-button">
                <span style="font-size: 1.45rem;">Create Custom Bid</span>
                <span class="selected-count">
                  {{ selectedPunksText }}
                </span>
              </button>
              <button (click)="cancelTargetedBidMode()">
                Cancel
              </button>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </div>

  <div
    class="filter-wrapper"
    *ngIf="filtersVisible">

    <div
      #filters
      class="filters-inner"
      [class.active]="filtersVisible">

      <div
        [id]="key"
        class="filter-group-wrapper"
        *ngFor="let key of objectKeys(dataSvc.filterData); let i = index">

        <ng-select
          [(ngModel)]="activeFiltersModel[key]"
          placeholder="{{ key | titlecase }}"
          (change)="selectFilter($event, key)"
          [searchable]="true">

          <ng-option
            *ngFor="let item of dataSvc.filterData[key]"
            [value]="item">

            {{ item | filterLabel }}
          </ng-option>
        </ng-select>
      </div>

      <div class="filter-group-wrapper">
        <ng-select
          [items]="[0, 1, 2, 3, 4, 5, 6, 7]"
          [(ngModel)]="traitCount"
          (change)="onTraitCountChange()"
          [searchable]="false"
          placeholder="Trait Count">
        </ng-select>
      </div>
      

      <div class="filter-group-wrapper" *ngIf="environment.collection === 'cryptopunks-v1'">
        <ng-select
          [items]="['Rainforest Punks', 'Survivor Punks']"
          [(ngModel)]="specialTraitV1"
          (change)="onSpecialTraitChange()"
          [searchable]="true"
          placeholder="Special">
        </ng-select> 

      </div>
      
    </div>
  </div>

        
  <!-- Description du trait spécial sélectionné -->
  <div class="special-trait-description" *ngIf="specialTraitV1">
    <p class="description-text">
      <strong>{{ specialTraitV1 }}</strong>: {{ selectedTraitDescription }}
    </p>
  </div>  
</ng-container>

<div *ngIf="(stateSvc.activeMarketplaceFilters$ | async) === 'CigStrategy'" class="coming-soon-msg" style="margin-top: 6rem; text-align:center; font-weight: 400;">
  <a href="https://x.com/cigstrategy" target="_blank" style="text-decoration: none; color: rgba(var(--text-color), 1); font-size: 2.4rem;">
    <svg viewBox="0 0 1635 300" class="cigstrategy-logo">
      <defs>
        <style>
          .cls-1 {
            fill-rule: evenodd;
          }
        </style>
      </defs>
      <path id="CigStrategy_copy" data-name="CigStrategy copy" class="cls-1" d="M15.374,46.382q-2.142,3.72-4.014,7.746-11.3,24.3-11.3,56.187v21.05q0.464,31.113,11.609,54.64t31.653,36.3q20.508,12.769,47.442,12.769,38.541,0,61.759-20.2t26.623-56.264h-39q-3.1,24.145-14.7,34.517T90.765,203.5q-25.231,0-38.309-19.21T39.377,128.512V108.526q0.308-36.1,14.008-54.767a47.112,47.112,0,0,1,6.687-7.387M250.5,64.5H212.891V231.977H250.5V64.5ZM216.064,35.168q5.492,5.652,15.711,5.65t15.788-5.65A19.352,19.352,0,0,0,253.135,21,19.815,19.815,0,0,0,247.563,6.61Q241.991,0.885,231.775.883T216.064,6.61A19.961,19.961,0,0,0,210.569,21,19.492,19.492,0,0,0,216.064,35.168ZM303.517,211.7q18.651,23.373,48.061,23.372,27.086,0,43.34-18.109v11.3q0,19.655-10.835,29.8T354.519,268.2q-25.388,0-42.721-20.586l-17.8,22.6q9.13,12.381,26.7,20.044a89.173,89.173,0,0,0,35.987,7.662q34.827,0,55.336-19.038t20.509-52.008V64.5h-33.9l-1.7,16.872Q380.521,61.4,351.888,61.4q-30.339,0-48.68,23.3T284.866,147Q284.866,188.326,303.517,211.7Zm29.1-104.79q10.291-14.7,28.867-14.7,22.754,0,33.434,19.038v73.678q-10.992,19.5-33.743,19.5-18.266,0-28.558-14.472t-10.293-39.7Q322.324,121.617,332.617,106.91ZM470.3,66.047q0,31.112,30.8,50.46,16.1,10.063,43.339,18.265t37.691,16.252q10.448,8.051,10.448,22.908,0,13.623-10.293,21.9t-30.725,8.281q-23.682,0-36.375-10.525t-12.692-29.719H463.333q0,21.208,11.377,37.149t31.885,25a110.082,110.082,0,0,0,44.966,9.055q36.991,0,58.586-16.639t21.592-44.81q0-17.334-7.429-30.261t-23.373-22.908q-15.943-9.984-42.256-17.8t-37.768-16.1q-11.457-8.279-11.454-20.664M538.976,35.54a73.242,73.242,0,0,1,10.882-.759q20.585,0,31.653,9.984t11.068,27.629h39.006A63.33,63.33,0,0,0,621.059,36.87a68.871,68.871,0,0,0-28.945-24.688q-18.422-8.667-41.947-8.668-5.724,0-11.1.46m132.92,19.817V64.5H644.432V92.361h27.551v94.884q0,47.829,43.34,47.828a92.663,92.663,0,0,0,24.766-3.56v-29.1a57.887,57.887,0,0,1-13.157,1.548q-9.751,0-13.544-4.257T709.6,185.851V92.361H739.16V64.5H709.6V23.791H671.983Zm183.73,39.78A35.234,35.234,0,0,0,842.4,61.4q-24.147,0-37.768,21.825L803.706,64.5H767.8V231.977h37.613V117.436q8.976-19.812,34.827-19.813a93.165,93.165,0,0,1,15.324,1.238ZM1013.13,231.977v-2.632q-6.345-13.465-6.35-36.065V117.745q-0.465-26.776-17.951-41.559T941.929,61.4a87.262,87.262,0,0,0-35.059,6.811q-15.712,6.813-24.843,18.806t-9.133,25.772h37.613q0-9.9,8.2-16.33t21.051-6.424q14.859,0,22.134,7.817t7.275,20.819v10.99H946.108q-37,0-56.884,14.317t-19.889,41.1q0,21.209,15.942,35.6t41.173,14.4q26,0,43.959-18.729,1.857,10.838,4.334,15.634h38.387Zm-98.985-33.511q-7.2-6.422-7.2-17.259,0-13.309,10.526-20.586t31.421-7.275h20.277v31.576a36.194,36.194,0,0,1-14.782,14.55,42.774,42.774,0,0,1-20.973,5.417Q921.343,204.889,914.145,198.466Zm180.345-3.561a29.948,29.948,0,0,1-1.18-9.054V92.361h29.56V64.5h-29.56V23.791H1055.7V64.5h-27.56V92.361h27.56v94.884q0,4.031.3,7.721m207.03,31.826a67.7,67.7,0,0,0,26.86-23.295l-20.28-19.348q-16.26,20.9-42.1,20.9-18.42,0-30.57-12.073t-13.86-32.815h109.44V144.988q0-39.936-18.65-61.76T1221.01,61.4A71.82,71.82,0,0,0,1182,72.393a73.57,73.57,0,0,0-27.16,30.725q-9.675,19.736-9.68,44.81v4.644q0,37.461,22.21,59.979t57.97,22.521Q1246.235,235.072,1263.03,226.791Zm-17.72-125.53q8.82,9.675,10.06,28.557V132.6H1183.7q2.64-19.347,12.15-30.183,9.525-10.833,25-10.835Q1236.48,91.587,1245.31,101.261ZM1333.77,211.7q18.645,23.373,48.06,23.372,27.075,0,43.34-18.109v11.3q0,19.655-10.84,29.8T1384.77,268.2q-25.395,0-42.72-20.586l-17.8,22.6q9.135,12.381,26.7,20.044a89.156,89.156,0,0,0,35.99,7.662q34.815,0,55.33-19.038t20.51-52.008V64.5h-33.9l-1.7,16.872Q1410.77,61.4,1382.14,61.4q-30.345,0-48.68,23.3T1315.12,147Q1315.12,188.326,1333.77,211.7Zm29.1-104.79q10.29-14.7,28.86-14.7,22.755,0,33.44,19.038v73.678q-11,19.5-33.75,19.5-18.255,0-28.55-14.472t-10.3-39.7Q1352.57,121.617,1362.87,106.91ZM1524.54,64.5h-40.55l58.81,166.578-5.41,14.383q-4.185,12.219-11.38,17.4t-21.44,5.181l-7.12-.465v29.24a67.088,67.088,0,0,0,18.11,2.8q36.69,0,52.01-42.256L1634.13,64.5h-40.09l-34.05,113.613Z"/>
      <rect x="1094" y="195" width="35" height="40"/>
      <rect x="509" y="35" width="30" height="30"/>
      <path class="cls-1" d="M60,7h80V46H60V7ZM179,46v66H140V46h39Z"/>
    </svg>
    <br/>
    
    
    Coming soon... Check out our 
      <svg width="20" viewBox="0 0 1200 1227" style="fill: rgba(var(--text-color), 1);" xmlns="http://www.w3.org/2000/svg">
        <path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" />
      </svg>      
      page for updates!
  </a>
</div>


<ng-container *ngIf="stateSvc.marketLoading$ | async">
  <app-loader></app-loader>
  <span class="loaderText">Loading...</span>
</ng-container>

<ng-container *ngIf="!(stateSvc.marketLoading$ | async)">
  
  <div
    *ngIf="punkData; else placeholder"
    class="grid-wrapper"
    [class.listing]="marketType === 'listings' || marketType === 'nftx-vault'"
    [class.bid]="marketType === 'bids'"
    [class.all]="marketType === 'all'"
    [class.hideMarketplaceIcons]="stateSvc.hideMarketplaceIcons$ | async"
    [class]="viewType">

    
    @if (marketType === 'sales') {
      @for (item of (filteredPunks | properties : (activeFilters$ | async) : traitCount); track item.id; let i = $index) {
        @if (i < (currentPage * limit)) {
          <ng-container *ngTemplateOutlet="punkItem; context:{ $implicit: item, idx: i }"></ng-container>
        }
      }

      @if (viewType !== 'compact' && punkData && punkData.length > 0) {
        @if (stateSvc.loadingMore$ | async) {
          <div class="load-more" style="transform: translateY(15px)">
            <app-loader></app-loader>
          </div>
        }
        @if (!(stateSvc.loadingMore$ | async)) {
          <button class="load-more" (click)="loadMoreSales()">
            <div>
              Load more sales<br/>
              <span>(before {{(punkData[punkData.length-1].blockTimestamp! * 1000) | date}})</span>
            </div>
          </button>
        }
      }
    } @else {

      @if (
        filteredPunks |
        properties : (activeFilters$ | async) : traitCount |
        filter: marketType : (activeWrappedFilters$ | async) |
        marketplace : (stateSvc.activeMarketplaceFilters$ | async) |
        sort: ((activeSort$ | async)?.value || sorts[0].value) : marketType;
        as data
      ) {
        
        @for (item of data; track item.id; let i = $index) {
          @if (shouldShowItem(i)) {
            <ng-container *ngTemplateOutlet="punkItem; context:{ $implicit: item, idx: i }"></ng-container>
          }
        }

        @if (viewType !== 'compact' && shouldShowLoadMoreButton) {
          <button class="item load-more" (click)="handleLoadMore()">Load More</button>
        }
      }
    }

  </div>
</ng-container>

<ng-template #punkItem let-item>
  <div class="item">
  
    <ng-container *ngIf="viewType !== 'compact'">
      <ng-container
        *ngIf="!item.wrapped && item.listing?.nativePunksmarket && environment.collection === 'cryptopunks-v1'">
        <a
          href="https://punksmarket.app/"
          target="_blank"
          rel="noopener noreferrer"
          class="listing-source unwrapped"
          title="PunksMarket native listing">
          <img src="/images/larvalabs.svg" alt="Native V1 (Larva Labs)" />
        </a>
      </ng-container>

      <ng-container
        *ngIf="marketType === 'sales' && isPunksmarketNativeSale(item) && environment.collection === 'cryptopunks-v1'">
        <a
          [href]="punksmarketPunkUrl(item.id)"
          target="_blank"
          rel="noopener noreferrer"
          class="listing-source unwrapped"
          title="PunksMarket native sale">
          <img src="/images/larvalabs.svg" alt="Native V1 (Larva Labs)" />
        </a>
      </ng-container>

      <ng-container *ngIf="item.listing?.source as source">
        <a
          [href]="source.name === 'NFTX' ? 'https://v2.nftx.io/vault/' + nftxVaultAddress : source.url"
          target="_blank"
          class="listing-source"
          [class]="source.name">

          <img
            [src]="source.name === 'nftx.io' ? '/assets/nftx.svg' : source.icon"
            width="20"
            height="20"
          />
        </a>
      </ng-container>
      
      <div *ngIf="item.fromAccount?.id == tokenworksAddressLower || item.toAccount?.id == tokenworksAddressLower || item.listing?.punk?.owner?.id === tokenworksAddressLower" class="listing-source">
        <app-marketplace-icons type="tokenworks" size="2rem" contextClass="grid-view"></app-marketplace-icons>
      </div>

      <div *ngIf="item.fromAccount?.id == punkauctionAddressLower || item.toAccount?.id == punkauctionAddressLower || item.listing?.punk?.owner?.id === punkauctionAddressLower" class="listing-source punkauction">
        <app-marketplace-icons type="punkauction" size="2rem" contextClass="grid-view"></app-marketplace-icons>
      </div>      
    
      <ng-container *ngIf="item.platform == 'blur'">
        <a
          href="https://blur.io"
          target="_blank"
          class="listing-source blur">

          <img
            src="https://blur.io/favicons/180.png"
            width="20"
            height="20"
          />
        </a>
      </ng-container>  

      <ng-container *ngIf="item.platform == 'opensea'">
        <a
          href="https://opensea.io"
          target="_blank"
          class="listing-source opensea">

          <img
            src="/images/opensea-logo.svg"
            width="20"
            height="20"
          />
        </a>
      </ng-container>            
    </ng-container>

    

    <a
      class="item-link"
      [class.selected]="isTargetedBidMode && selectedPunkIdsSet.has(parseInt(item.id))"
      [routerLink]="!isTargetedBidMode ? (item.listing?.source?.internal ? item.listing?.source?.internal : ['/', 'details', item.id]) : null"
      [href]="!isTargetedBidMode ? (item.listing?.source?.internal ? item.listing?.source?.internal : '/details/' + item.id) : null"
      (click)="handlePunkClick(item, $event)">

      <div
        class="image-wrapper"
        [class.listing]="(marketType === 'listings' || marketType === 'nftx-vault') && item?.listing && !item.listing?.nativePunksmarket"
        [class.native-v1-listing]="((marketType === 'listings' || marketType === 'nftx-vault' || marketType === 'all') && item?.listing?.nativePunksmarket) || (marketType === 'sales' && isPunksmarketNativeSale(item) && !item?.wrapped)"
        [class.bid]="marketType === 'bids' && item?.bid"
        [class.all]="marketType === 'all'"
        [class.wrapped]="item?.wrapped"
        [class.c721wrapped]="item?.c721wrapped">
        <ng-container *ngIf="marketType != 'nftx-vault' && (item.listing?.source?.name === 'NFTX' || item.listing?.source?.name === 'nftx.io') && (stateSvc.activeMarketplaceFilters$ | async) !== 'NFTX'">
          <div class="label-overlay">View vault</div>
        </ng-container>

        <!-- Debug mode icon -->
        <div 
          *ngIf="environment.debugMode" 
          class="debug-icon"
          (click)="copyPunkJson(item, $event)"
          title="Click to copy punk JSON data">
          (i)
        </div>

        <img
          [lazyLoad]="dataSvc.staticUrl + dataSvc.tokenImagePath + (item.id | tokenIdParse) + '.svg'"
          [defaultImage]="environment.collection === 'cryptophunks' ? 'assets/loadingphunk.png' : 'assets/loadingpunk.png'"          
          width="50"
          height="50"
        />
      </div>

      <div
        class="labels-wrapper"
        *ngIf="viewType !== 'compact'">

        <div class="label">#{{ item.id }}</div>

        @if (marketType === 'sales') {
          <p i18n>
            {{ (item.value | weiToEth) | formatCash }}Ξ<br />
            ${{ ((item.value | weiToEth) | usd : item.usd) | formatCash }}
          </p>

          <div class="date">
            {{ (+item.blockTimestamp * 1000) | timeago : true }}
          </div>
        } @else if (marketType === 'listings' || marketType === 'nftx-vault') {
          @if (item.listing; as listing) {
            <p i18n>
              {{ (listing.value | weiToEth) | formatCash }}Ξ<br />
              ${{ ((listing.value | weiToEth) * ((dataSvc.usd$ | async) || 0)) | formatCash }}
            </p>
          }
        } @else if (marketType === 'bids') {
          @if (item.bid; as bid) {
            <p i18n>
              {{ (bid.value | weiToEth) | formatCash }}Ξ<br />
              ${{ ((bid.value | weiToEth) * ((dataSvc.usd$ | async) || 0)) | formatCash }}
            </p>
          }
        }

      </div>
    </a>

  </div>
</ng-template>

<ng-template #placeholder>
  <div
    class="grid-wrapper"
    [class]="viewType">

    <div class="item-link" *ngFor="let i of limitArr">
      <div class="item">

        <div class="image-wrapper">
          <img
            [src]="'assets/loadingpunk.png'"
            width="50"
            height="50"
          />
        </div>
  
        <div
          class="labels-wrapper"
          *ngIf="viewType !== 'compact'">
  
          <div class="label">#0000</div>
          <div class="label">Loading...<br />&nbsp;</div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #prevIcon>
  <svg height="13" viewBox="0 0 8 13" width="8" xmlns="http://www.w3.org/2000/svg"><path d="m5.203125 10.40625v2.5664062h2.6015625v-2.5664062zm-2.6015625-2.6015625v2.6015625h2.6015625v-2.6015625zm-2.6015625-2.6015625v2.6015625h2.6015625v-2.6015625zm2.6015625-2.6015625v2.6015625h2.6015625v-2.6015625zm2.6015625-2.6015625v2.6015625h2.6015625v-2.6015625z" fill="rgba(var(--text-color), 1)"/></svg>
</ng-template>

<ng-template #nextIcon>
  <svg height="13" viewBox="0 0 8 13" width="8" xmlns="http://www.w3.org/2000/svg"><path d="m2.6015625 10.40625v2.5664062h-2.6015625v-2.5664062zm2.6015625-2.6015625v2.6015625h-2.6015625v-2.6015625zm2.6015625-2.6015625v2.6015625h-2.6015625v-2.6015625zm-2.6015625-2.6015625v2.6015625h-2.6015625v-2.6015625zm-2.6015625-2.6015625v2.6015625h-2.6015625v-2.6015625z" fill="rgba(var(--text-color), 1)"/></svg>
</ng-template>

<ng-template #nftxIcon>
  <svg viewBox="0 0 1400 1400" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><linearGradient id="a" gradientUnits="userSpaceOnUse" x1="958.46" x2="460.73" y1="277.79" y2="775.52"><stop offset=".09" stop-color="#ff6d41"/><stop offset=".5" stop-color="#fa297f"/><stop offset="1" stop-color="#fa297f"/></linearGradient><linearGradient id="b" gradientUnits="userSpaceOnUse" x1="820.59" x2="320.81" y1="147.54" y2="647.31"><stop offset="0" stop-color="#652cb4"/><stop offset=".07" stop-color="#652cb4" stop-opacity=".82"/><stop offset=".19" stop-color="#652cb4" stop-opacity=".53"/><stop offset=".3" stop-color="#652cb4" stop-opacity=".3"/><stop offset=".4" stop-color="#652cb4" stop-opacity=".14"/><stop offset=".49" stop-color="#652cb4" stop-opacity=".04"/><stop offset=".55" stop-color="#652cb4" stop-opacity="0"/></linearGradient><path d="m700 0-536.25 536.25 536.25 513.79 536.25-513.79z" fill="url(#a)"/><path d="m430.13 992.57c11.81-15.81 23-30.82 36.4-45.41-161.17 38.84-272.16 120.18-272.16 214.32 0 3.51.19 7 .49 10.46 15.81-6 32.49-13.18 50.21-21.89 106.46-52.3 148.22-108.18 185.06-157.48z" fill="rgba(var(--text-color), 1)" /><path d="m598 1165.6c32.23-43.13 60.06-80.37 138.73-119s125.17-37.91 179-37.08c36.06.57 74.95 1.16 122.39-9-57.85-31.08-132.23-54.59-216.3-67.2l-121.82 116.68-85.15-81.58c-60.68 40.86-91.77 82.41-120 120.12-32.23 43.13-60.06 80.38-138.73 119-55.18 27.1-94.52 34.83-131.68 36.74 29.31 38.87 78.66 73 141.86 99.24 14.72-5.71 30.2-12.47 46.55-20.5 106.52-52.24 148.28-108.12 185.15-157.42z" fill="rgba(var(--text-color), 1)" /><path d="m1085.56 1053.89c-61.54-1-131.28-2.07-237.75 50.24s-148.23 108.18-185.07 157.49c-32.23 43.12-60.06 80.37-138.74 119-3.56 1.75-7 3.4-10.48 5a945.94 945.94 0 0 0 166.28 14.38q18.44 0 36.51-.67c19.69-20.84 35-41.28 49.5-60.69 32.22-43.13 60.06-80.38 138.73-119s125.18-37.9 179-37.07c24.78.39 50.9.79 80.21-2.27a120.24 120.24 0 0 0 1.49-18.79c0-38.63-18.71-75.1-51.88-107.37-9.18.04-18.36-.14-27.8-.25z" fill="rgba(var(--text-color), 1)" /><path d="m874.43 1380c127.17-27.38 225.86-80.77 268.22-146.47-36.37 6.64-77.75 19.39-127 43.6-68.65 33.75-110.35 68.94-141.22 102.87z" fill="rgba(var(--text-color), 1)" /><path d="m700 536.25h-536.25l536.25-536.25z" fill="url(#b)" opacity=".5"/></svg>
</ng-template>

<!-- Copy bid: review punks (trait / targeted / owner), same flow as market -->
<app-bid-copy-confirmation-modal
  [isActive]="copyConfirmationModalActive"
  [punkIds]="copyConfirmationPunkIds"
  (confirmed)="onCopyHighestBidConfirmationConfirmed()"
  (cancelled)="onCopyHighestBidConfirmationCancelled()">
</app-bid-copy-confirmation-modal>

<!-- Bid Creation Modal Component -->
<app-bid-creation-modal
  [isActive]="createCollectionBidModalActive"
  [bidType]="copyFromBidPayload?.bidType ?? bidType"
  [punkIndices]="copyFromBidPayload?.punkIndices ?? filteredPunkIndices"
  [selectedPunkIds]="copyFromBidPayload?.selectedPunkIds ?? selectedPunkIds"
  [activeTraits]="copyFromBidPayload?.activeTraits ?? activeTraitsList"
  [filterTag]="copyFromBidPayload?.filterTag ?? filterTag"
  [copyFromBid]="copyFromBidPayload"
  (modalClosed)="closeCreateCollectionBid()"
  (bidCreated)="onBidCreated()">
</app-bid-creation-modal>

<!-- Highest Bid Details Modal -->
<app-bid-details-modal
  [isActive]="highestBidDetailsModalActive"
  [bid]="highestBidForCriteria"
  (closed)="highestBidDetailsModalActive = false"
  (copyBid)="onCopyHighestBid($event)">
</app-bid-details-modal>

<!-- Highest Bid (Any match) Details Modal -->
<app-bid-details-modal
  [isActive]="highestBidAnyDetailsModalActive"
  [bid]="highestBidForCriteriaAny"
  (closed)="highestBidAnyDetailsModalActive = false"
  (copyBid)="onCopyHighestBid($event)">
</app-bid-details-modal>

